module["exports"] = [
  "آقای",
  "خانم",
  "دکتر"
];
